import { useState } from "react";
import db from '../firebase'
import {v4 as uuidv4} from 'uuid'
import '../styles/Editor.css'
import emailjs from 'emailjs-com'
// import '../smtp'

function Form(){
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [date, setDate] = useState('')
    const [phone, setPhone] = useState('')
     // const [email, setEmail] = useState('')
    const [description, setDescription] = useState('')
    const approved = false
    // Social
//    function handleURL() {
//         const i = document.getElementById("title");
//         const c = document.getElementById("description");
//         const u = document.getElementById("image-url");
//         i.srcdoc = i.value;
//         window.location.hash = btoa(JSON.stringify({ h: i.value, c: c.value, u: u.value }));
//         document.getElementById('url').href = "/user" + window.location.hash
//       }
    const handleDB = async (e) => {
        e.preventDefault();
        let code = uuidv4();
        await db.collection("data").add({
            code: code,
            name: name,
            email: email,
            date: date,
            description: description,
            approved: approved,
            phone: phone
        })
        // const url = 'catasco-appointment.netlify.app/receipt/' + code
        // client.send(
        //     {
        //         text: `Your appointment with CA Tarak Shah has been sent and will be reviewed soon. Check out your appointment receipt ${url}`,
        //         from: 'ds.developer24@gmail.com',
        //         to: email,
        //         // cc: 'else <else@your-email.com>',
        //         subject: `${name}'s Appointment with CA Tarak Shah'`,
        //     },
        //     (err, message) => {
        //         console.log(err || message);
        //     }
        // );
        // emailjs.sendForm('gmail', 'client', e.target, 'user_OW7gDyw6n0XsG4q53E3Nb')
        // .then((result) => {
        //     console.log(result.text);
        // }, (error) => {
        //     console.log(error.text);
        // });

        const params = {
            code: code,
            name: name,
            email: email,
            date: date,
            message: description,
            phone: phone
        }
        emailjs.send('gmail', 'author', params, 'user_OW7gDyw6n0XsG4q53E3Nb')
                    .then((result) => {
                        console.log(result.text);
                    }, (error) => {
                        console.log(error.text);
                    })
        window.open('/receipt/' + code,'_blank')
        document.getElementById('btn').disabled = true

    }
        return(
            <div className="container">
            <div>
                <center>
                  <div className="title">
                        <h1>CA Tarak A Shah & CO</h1>  
                    </div>      <hr />
                    
                </center>
                <div className="inputs">
                        <form onSubmit={handleDB}>
                        <input type="text" placeholder="Your good name" className="form-control" value={name} onChange={e => setName(e.target.value)} name="name" required/>
                        <br />
                        <input type="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email Address" name="email" required/>
                        <br />
                        <input type="tel" name="phone" id="phone" value={phone} onChange={e => setPhone(e.target.value)} placeholder="Enter Phone Number"  required className="form-control"/>
                         <hr />
                        <label align="left" className="fw-bolder mb-3">Choose Appointment Date</label>
                        <input type="datetime-local" className="form-control" value={date} onChange={e => setDate(e.target.value)} name="date" required/>
                        <hr />
                        <textarea id="description" cols="30" rows="10" className="form-control" placeholder="Enter a query" value={description} onChange={e => setDescription(e.target.value)} name="message" required></textarea>
                        <br />
                        <input type="submit" value="Submit" id="btn" className="btn btn-primary" style={{width: '100%'}} required/>
                        </form>
                    </div>
                <hr />
                    <ul className="d-flex justify-content-between">
                        <li>
                        <a href="https://www.google.com/maps/dir/23.026197,72.5559743/Tarak+A.+Shah+%26+Co.+-+CAPSTONE,+Netaji+Rd,+nr.+Chirag+Motors,+Ellisbridge,+Ahmedabad,+Gujarat+380009,+India/@23.0246666,72.5527358,16z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x395e85147c4766ab:0x85e0da43c67e6920!2m2!1d72.5605681!2d23.0200303" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark fw-bolder">Reach Us</a>
                        </li>
                        <li>
                        <a href="mailto:catarakshah@gmail.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark fw-bolder">Email Us</a>
                        </li>
                        <li>
                        <a href="tel:+919377416704" target="_blank" rel="noopener noreferrer" className="text-decoration-none text-dark fw-bolder">Contact Us</a>
                        </li>
                    </ul>
                    </div>
            </div>
        )
}

export default Form